// form 必填字段校验
import {message} from 'ant-design-vue'
import {loadNum} from '@/utils/util'

export function validateFields(map) {
  var a = {}
  var id = ''
  var value = ''
  for (var entry of map.entries()) {
    var v = entry[1]
    if (v === undefined) {
      id = ''
    } else {
      id = v.id
      value = v.value
      if (id === undefined) {
        id = v
      } else if (value === undefined || value === '' || id === '0') {
        id = ''
      }
    }
    a[entry[0]] = id
  }
  return a
}

// 传入map 进行类型转换
export function checkFieldType(map) {
  const a = {};
  let id = '';
  let value = '';
  for (const entry of map.entries()) {
    const v = entry[1];
    if (v === undefined) {
      id = ''
    } else if (typeof (v) === 'object') {
      id = v
    } else {
      id = v.id
      value = v.value
      if (id === undefined || id === null) {
        id = v
      } else if (value === undefined || value === '' || id === '0') {
        id = []
      }
    }
    a[entry[0]] = id
  }
  return a
}

// Table输入的是否为数字及零散数应小于包装数
export function numCheck(column, target, reg) {
  // var reg = /^\d*\.?\d{0,5}$/
  if (column === 'cases') {
    if (!target['cases'].match(reg)) {
      message.error('请输入数字')
      target['cases'] = 0
    } else {
      loadNum(0, target['eachs'], target['cases'], target['factor'], target)
    }
  } else if (column === 'eachs') {
    if (!target['eachs'].match(reg)) {
      message.error('请输入数字')
      target['eachs'] = 0
    } else {
      loadNum(0, target['eachs'], target['cases'], target['factor'], target)
    }
  } else if (column === 'planQuantity') {
    if (!target['planQuantity'].match(reg)) {
      message.error('请输入数字')
      target['planQuantity'] = 0
    } else {
      loadNum(target['planQuantity'], 0, 0, target['factor'], target)
    }
  }
  if (target['eachs'] >= target['factor']) {
    message.error('零散数应小于包装数')
    target['eachs'] = 0
  }
  if (target['planQuantity'] > target['quantity']) {
    alert('数量大于可开票数')
    target['planQuantity'] = 0
    loadNum(target['planQuantity'], 0, 0, target['factor'], target)
  }
}

export function fileIsNull(map) {
  var arr = {}
  var a = []
  var text = ''
  for (var entry of map.entries()) {
    var v = entry[1]
    if (v === undefined || v === '' || v === '0') {
      arr[entry[0]] = text
      a.push(arr)
    }
  }
  if (a.length > 0) {
    return true
  } else {
    return false
  }
}


export function validateFieldsConvert(map) {
  var a = {}
  var id = ''
  var value = ''
  var targetField = new Map()
  for (var entry of map.entries()) {
    var v = entry[1]
    console.log(typeof (v))
    if ((v.length > 0 && v !== [] && v !== '') || (entry[0] === 'dateFilter')) {
      targetField.set(entry[0], entry[1])
    }
    if (typeof (v) === 'number' && v === 0) {
      targetField.set(entry[0], entry[1])
    }
  }
  return targetField
}

export function check(column, target, reg) {
  if (column === 'length') {
    if (!target['length'].match(reg)) {
      message.error('请输入数字')
      target['length'] = 0
    } else {
      loadVolume(target['length'], target['width'], target['height'], target)
    }
  } else if (column === 'width') {
    if (!target['width'].match(reg)) {
      message.error('请输入数字')
      target['width'] = 0
    } else {
      loadVolume(target['length'], target['width'], target['height'], target)
    }
  } else if (column === 'height') {
    if (!target['height'].match(reg)) {
      message.error('请输入数字')
      target['height'] = 0
    } else {
      loadVolume(target['length'], target['width'], target['height'], target)
    }
  }
}


export function loadVolume(length, width, height, target) {
  const _length = length === '' ? 0 : length
  const _width = width === '' ? 0 : width
  const _height = height === '' ? 0 : height
  let volume = 0

  volume = parseFloat(_length) * parseFloat(_width) * parseFloat(_height)

  target['volume'] = volume
}

